module.exports = __webpack_public_path__ + "static/media/filters.5d49da71.svg";